import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Shield, MessageSquare, Calendar, Sun } from 'lucide-react';
export function Contents() {
  const items = [{
    icon: BookOpen,
    title: 'Guía completa del Interruptor 3AM',
    desc: 'El paso a paso exacto.'
  }, {
    icon: Shield,
    title: 'Las 6 Reglas de Oro',
    desc: 'Para no sabotearte sin darte cuenta.'
  }, {
    icon: MessageSquare,
    title: 'Tarjetas de Rescate',
    desc: 'Frases exactas para cuando tu mente se pone cruel.'
  }, {
    icon: Calendar,
    title: 'Plan de 7 Noches',
    desc: 'Para bajar el miedo anticipatorio.'
  }, {
    icon: Sun,
    title: 'Protocolo “Día Siguiente”',
    desc: 'Para que una mala noche no destruya tu día.'
  }];
  return <section className="py-24 px-6 bg-slate-900 border-y border-slate-800" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        <FadeIn data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-16 text-center" data-id="element-35">
            Lo que incluye (sin relleno)
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-36">
          {items.map((item, idx) => <FadeIn key={idx} delay={idx * 100} data-id="element-37">
              <div className="flex items-start gap-4 p-6 rounded-xl bg-slate-950 border border-slate-800 h-full hover:border-amber-500/30 transition-all" data-id="element-38">
                <item.icon className="w-6 h-6 text-amber-500 shrink-0" data-id="element-39" />
                <div data-id="element-40">
                  <h3 className="text-lg font-bold text-white mb-1" data-id="element-41">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-42">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}